import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "./styles/fonts.css";
import "./styles/components.css";
import "./styles/theme.css";

import i18n from "./i18n";

const savedTheme = localStorage.getItem("theme") || "1"; // 1 = dark, 2 = light
if (savedTheme === "1") {
    document.body.classList.remove("light-theme");
} else {
    document.body.classList.add("light-theme");
}

const savedLang = localStorage.getItem("lang") || "en";
i18n.changeLanguage(savedLang);

const saved = localStorage.getItem("audio");
if (saved === null || saved === undefined) {
    localStorage.setItem("audio", "1")
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
